<template>
  <div class="home" :key="key">
    
    <v-row class="d-flex flex-no-wrap justify-space-around align-center">
      <v-radio-group v-model="radio" row mandatory @change="radiochanged" dense>
        <v-radio label="Cards" value="Cards"></v-radio>
                <v-radio label="Table" value="Table"></v-radio>
      </v-radio-group>
    </v-row>
    <div v-if="radionumber == 1">
      <v-card max-width="600">
        <HappCard :items="items"></HappCard>
      </v-card>
      <!-- <AirboxCard :items="items"></AirboxCard> -->
    </div>
    <div v-if="radionumber == 2">
       <HappTable :items="items"></HappTable>
    </div>
      <!-- {{items[0]}} -->
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import HappTable from "@/components/happ/HappTable.vue";
import HappCard from "@/components/happ/HappCard.vue";

export default {
  name: "EventList",
  data() {
    return {
      eventId: 0,
      radio: null,
      radionumber: Number,
      items: [],
      errors: [],
      loading: true,
      key: Number,
      selectedBox: String,
      badgeIcon: String,
      badgeColor: String,
      regid: Number,
      ac: String,
    };
  },
  created() {
    this.eventId = this.$route.params.eventId;
    this.selectedBox = "";
    if (this.eventId == null) {
      this.eventId = 0;
    }
    this.selectedBox = "All";
    this.radionumber = 1;
    this.badgeIcon = "mdi-lock-outline";
    this.badgeColor = "red";
    this.getCookies();
    this.getHapp();
    this.key = 1;
    
  },
  methods: {
    getHapp() {
      var regId = this.regid;
      var ac = this.ac;
      var happId = 0;
      var toSubmit = JSON.stringify({ happId, regId, ac });
      console.log(toSubmit);
      const baseUrl = "https://pgapi.azurewebsites.net/dbapi/"
      const uri = baseUrl + "gethapp";
      this.sendpost(uri,toSubmit);
   
    },
    radiochanged() {
      if (this.radio == "Cards") {
        this.radionumber = 1;
      }
      if (this.radio == "Table") {
        this.radionumber = 2;
      }
    },
    sendpost(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "POST",
        },
      };
      axios
        .post(uri,toSubmit,axiosConfig)
        .then((response) => {
          this.items = response.data;
          console.log(this.items);
          
          this.loading = false;
          let arr = this.items;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].RegId == this.cookieRegId) {
              this.items[i].Enabled = this.loggedIn;
            }
          }
          this.items = arr;
          if (this.eventId > 0) {
            this.selectedBox = this.items[0].Event;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regid = this.cookieRegId;
      this.ac = this.cookieToken;
      if(this.regid == undefined) {
        this.regid = 0;
      }
      if(this.ac == undefined) {
        this.ac = "0";
      }
      if (this.cookieToken > 0) {
        this.loggedIn = true;
        this.badgeIcon = "mdi-lock-open";
        this.badgeColor = "green";
      }
    },
    refresh() {
      this.key++;
    },
  },
  components: {
    HappTable,
    HappCard
    },
};
</script>